import {TaskListItem} from '../../types/tasks.types';

const MAX_CODE_LEN:number=16;

export const StepFour=function(props:{classCode:string, classCodeAltered:(code: string) => void, tasksList:TaskListItem[]}){
	const existingCodes = Array.from(new Set(
		props.tasksList
			.map(t => t.meta?.classCode)
			.filter((code): code is string => code !== undefined && code !== '')
	));

	let clearButVisible=props.classCode.length>1;

	return(
		<div className='teachers-taskcreater-step'>
			<hr />
			<h3>Step 4 - Optional</h3>
			<p>Enter a class code</p>
			<div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
				<input
					className="teachers-taskcreater-input"
					type='text'
					placeholder='Class code...'
					value={props.classCode}
					onChange={(e)=>props.classCodeAltered(e.target.value)}
					maxLength={MAX_CODE_LEN}>
				</input>
				{clearButVisible && (
					<button
						id='teachers-taskcreater-clear'
						onClick={() => props.classCodeAltered('')}>
						x
					</button>
				)}
			</div>
			{existingCodes.length > 0 && (
				<div style={{marginTop: '12px'}}>
					<div style={{display: 'flex', flexWrap: 'wrap'}}>
						{existingCodes.map(code => (
							<span
								key={code}
								className='teachers-listitem-classcode'
								onClick={() => props.classCodeAltered(code)}
								style={{cursor: 'pointer'}}>
								{code}
							</span>
						))}
					</div>
				</div>
			)}
		</div>
	)
};
